/* Carska - deterministyczny drawer na Shopify AJAX Cart API + oferty warunkowe (beta). Wymaga carska-cart-core.js. */
(function () {
  var core = window.CarskaCartCore;
  if (!core) return;

  var THRESHOLD = 25000; // 250 zł; sprawdzenie konfiguracji dostawy jest bramką przed cutoverem.
  /* Oferty warunkowe (beta, bez rabatow). Projekt i dane: migracja/raporty/warunkowe-oferty-koszyka-projekt-2026-09-02.md.
     Silnik wyboru: CarskaCartCore.buildOfferPlan. Tu tylko konfiguracja. Gorzki Kompleks celowo poza lista. */
  var OFFER_CART_THRESHOLD = 32000; // 320 zł
  var OFFER_MAX = 3;
  var OFFER_RULES = {
    highCart: [
      { handle: 'carska-omega-3-puder-z-pachnotki-zwyczajnej-250-g', label: 'Odkryj coś nowego', note: 'Propozycja spoza dotychczasowych zakupów.', featured: true },
      { handle: 'carska-zakwas-zoladkowy-21-buteleczek-10-ml', label: 'Format na wyjazd', note: '21 małych buteleczek w wygodnym formacie poza domem.' }
    ],
    anchors: [
      { handle: 'carska-witamina-d3k2mk7-jod-gratis', offers: [
        { handle: 'carska-oryginalny-zakwas-zoladkowy-kompleks-ziolowy-500-ml', label: 'Często wybierane razem' },
        { handle: 'carska-magnez-4-formy-magnezu-50-ml', label: 'Często wybierane razem' },
        { handle: 'carska-cynk-50-ml', label: 'Często wybierane razem' },
        { handle: 'carska-selen-50-ml', label: 'Często wybierane razem' },
        { handle: 'carska-niacyna-witamina-b3-60-kapsulek', label: 'Często wybierane razem' },
        { handle: 'carska-maslan-sodu-forte', label: 'Często wybierane razem' } ] },
      { handle: 'carska-oryginalny-zakwas-zoladkowy-kompleks-ziolowy-500-ml', offers: [
        { handle: 'carska-maslan-sodu-forte', label: 'Najczęściej dobierane' },
        { handle: 'carska-witamina-d3k2mk7-forte-50-ml-krople', label: 'Najczęściej dobierane' },
        { handle: 'carska-magnez-4-formy-magnezu-50-ml', label: 'Najczęściej dobierane' } ] },
      { handle: 'zakwas-zapas-2-miesiace', offers: [
        { handle: 'carska-maslan-sodu-forte', label: 'Najczęściej dobierane' },
        { handle: 'carska-witamina-d3k2mk7-forte-50-ml-krople', label: 'Najczęściej dobierane' },
        { handle: 'carska-magnez-4-formy-magnezu-50-ml', label: 'Najczęściej dobierane' } ] },
      { handle: 'carska-witamina-d3k2mk7-forte-50-ml-krople', offers: [
        { handle: 'carska-magnez-4-formy-magnezu-50-ml', label: 'Często wybierane razem' },
        { handle: 'carska-cynk-50-ml', label: 'Często wybierane razem' },
        { handle: 'carska-koenzym-q10-ubichinol-kaneka-60-kapsulek', label: 'Często wybierane razem' } ] },
      { handle: 'carska-magnez-4-formy-magnezu-50-ml', offers: [
        { handle: 'carska-cynk-50-ml', label: 'Mineralny duet' },
        { handle: 'carska-potas-50-ml', label: 'Mineralny duet' },
        { handle: 'carska-selen-50-ml', label: 'Mineralny duet' } ] },
      { handle: 'carska-maslan-sodu-forte', offers: [
        { handle: 'carska-berberyna-ekstrakt-98-60-kapsulek', label: 'Często wybierane razem' },
        { handle: 'carska-koenzym-q10-ubichinol-kaneka-60-kapsulek', label: 'Często wybierane razem' },
        { handle: 'carska-magnez-4-formy-magnezu-50-ml', label: 'Często wybierane razem' } ] },
      { handle: 'carska-jod-z-mineralami-jonowymi-50-ml', offers: [
        { handle: 'carska-magnez-4-formy-magnezu-50-ml', label: 'Często wybierane razem' },
        { handle: 'carska-witamina-d3k2mk7-forte-50-ml-krople', label: 'Często wybierane razem' },
        { handle: 'carska-maslan-sodu-forte', label: 'Często wybierane razem' } ] },
      { handle: 'carska-berberyna-ekstrakt-98-60-kapsulek', offers: [
        { handle: 'carska-maslan-sodu-forte', label: 'Często wybierane razem' },
        { handle: 'carska-koenzym-q10-ubichinol-kaneka-60-kapsulek', label: 'Często wybierane razem' },
        { handle: 'carska-witamina-d3k2mk7-forte-50-ml-krople', label: 'Często wybierane razem' } ] }
    ],
    fallback: [
      { handle: 'carska-cynk-50-ml', label: 'Uzupełnij koszyk' },
      { handle: 'carska-selen-50-ml', label: 'Uzupełnij koszyk' },
      { handle: 'carska-potas-50-ml', label: 'Uzupełnij koszyk' }
    ]
  };
  var OFFER_FETCH_CAP = 8; // ile pozycji planu pobieramy, zanim odfiltrujemy dostepnosc
  var BAG_ICON = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h12l-1 10H5L4 7z"/><path d="M7 7V5.5a3 3 0 0 1 6 0V7"/></svg>';
  var X_ICON = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" aria-hidden="true"><path d="M2 2l8 8M10 2l-8 8"/></svg>';
  var drawer, overlay, lastOpener = null;
  var mutationQueue = Promise.resolve();
  var refreshController = null;
  var renderVersion = core.createRenderVersion();
  var upsellCache = {};

  function qs(selector, root) { return (root || document).querySelector(selector); }
  function qsa(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function money(cents) { return (Number(cents || 0) / 100).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' zł'; }
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }
  function safeUrl(value) {
    try {
      var url = new URL(String(value || ''), window.location.origin);
      return /^https?:$/.test(url.protocol) ? url.href : '#';
    } catch (error) { return '#'; }
  }
  function image(value, width) {
    var src = safeUrl(value);
    if (src === '#') return null;
    var node = document.createElement('img');
    node.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    node.alt = ''; node.loading = 'lazy';
    return node;
  }
  function icon(svg) { var box = document.createElement('span'); box.innerHTML = svg; return box.firstChild; } // svg to stala z tego pliku, nie dane
  function toast(message) {
    var node = qs('[data-cart-toast]');
    if (!node) return;
    node.textContent = message; node.classList.add('is-visible');
    clearTimeout(node._timer);
    node._timer = setTimeout(function () { node.classList.remove('is-visible'); }, 4000);
  }
  function errMsg(data, status) {
    var description = String((data && (data.description || data.message)) || '');
    if (status === 429) return 'Sklep chwilowo przetwarza zbyt wiele zmian. Spróbuj ponownie za moment.';
    if (/sold out|wyprzedan/i.test(description)) return 'Ten produkt jest chwilowo niedostępny w wybranej ilości.';
    if (/stock|magazyn/i.test(description)) return 'Brak wybranej ilości w magazynie.';
    return 'Nie udało się zaktualizować koszyka. Spróbuj ponownie.';
  }
  function isOpen() { return drawer && drawer.classList.contains('is-open'); }
  function setBusy(isBusy) {
    if (!drawer) return;
    drawer.classList.toggle('is-busy', isBusy); drawer.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    qsa('[data-cart-mutation]').forEach(function (node) { node.disabled = isBusy; });
  }
  function setOpeners(expanded) { qsa('[data-cart-open]').forEach(function (node) { node.setAttribute('aria-expanded', expanded ? 'true' : 'false'); }); }
  function focusables() {
    return qsa('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', drawer)
      .filter(function (node) { return node.offsetParent !== null; });
  }
  function openDrawer(opener) {
    if (!drawer) return;
    lastOpener = opener || document.activeElement;
    drawer.classList.add('is-open'); overlay.classList.add('is-open');
    document.documentElement.classList.add('ck-cart-open'); document.body.classList.add('ck-cart-open');
    drawer.setAttribute('aria-hidden', 'false'); setOpeners(true);
    refresh().then(function () { var first = isOpen() && focusables()[0]; if (first) first.focus(); });
  }
  function closeDrawer() {
    if (!isOpen()) return;
    drawer.classList.remove('is-open'); overlay.classList.remove('is-open');
    document.documentElement.classList.remove('ck-cart-open'); document.body.classList.remove('ck-cart-open');
    drawer.setAttribute('aria-hidden', 'true'); setOpeners(false);
    if (lastOpener && typeof lastOpener.focus === 'function') lastOpener.focus();
    lastOpener = null;
  }
  function setCount(count) {
    qsa('[data-cart-count],[data-cart-head-count]').forEach(function (node) { node.textContent = count; node.style.display = count > 0 ? '' : 'none'; });
  }
  function renderProgress(total) {
    var text = qs('[data-cart-progress-text]'); var fill = qs('[data-cart-progress-fill]');
    if (!text || !fill) return;
    var free = total >= THRESHOLD;
    text.replaceChildren(document.createTextNode(free ? 'Masz ' : 'Do darmowej dostawy brakuje '), el('strong', null, free ? 'darmową dostawę' : money(THRESHOLD - total)), document.createTextNode(free ? ' 🎉' : ''));
    fill.style.width = Math.min(100, free ? 100 : (total / THRESHOLD) * 100) + '%';
  }
  function renderLineDiscounts(item, body) {
    var list = el('ul', 'ci-discounts');
    (item.line_level_discount_allocations || []).forEach(function (allocation) {
      var title = allocation && allocation.discount_application && allocation.discount_application.title;
      if (title) list.appendChild(el('li', null, title));
    });
    if (list.childNodes.length) body.appendChild(list);
  }
  function renderItem(item, index) {
    var line = index + 1, row = el('div', 'ci'), productLink = el('a', 'ci-img'), body = el('div', 'ci-body');
    productLink.href = safeUrl(item.url); var productImage = image(item.image, 160); if (productImage) productLink.appendChild(productImage); row.appendChild(productLink);
    var title = el('a', 'ci-title', item.product_title || item.title || 'Produkt'); title.href = safeUrl(item.url); body.appendChild(title);
    if (item.variant_title && item.variant_title !== 'Default Title') body.appendChild(el('span', 'ci-variant', item.variant_title));
    renderLineDiscounts(item, body);
    if (item.has_components) { var bundle = el('div', 'ci-bundle'); bundle.dataset.bundleKey = item.key; bundle.hidden = true; body.appendChild(bundle); }
    var details = el('div', 'ci-row'), quantity = el('div', 'ci-qty');
    function quantityButton(className, text, amount, label) {
      var button = el('button', className, text); button.type = 'button'; button.dataset.line = line; button.dataset.qty = amount; button.dataset.cartMutation = ''; button.setAttribute('aria-label', label); return button;
    }
    quantity.appendChild(quantityButton('ci-dec', '−', Math.max(0, item.quantity - 1), 'Zmniejsz ilość'));
    quantity.appendChild(el('span', null, item.quantity));
    quantity.appendChild(quantityButton('ci-inc', '+', item.quantity + 1, 'Zwiększ ilość'));
    details.appendChild(quantity); details.appendChild(el('span', 'ci-price', money(item.final_line_price))); body.appendChild(details);
    row.appendChild(body);
    var remove = el('button', 'ci-x'); remove.type = 'button'; remove.dataset.line = line; remove.dataset.qty = '0'; remove.dataset.cartMutation = ''; remove.setAttribute('aria-label', 'Usuń'); remove.appendChild(icon(X_ICON)); row.appendChild(remove);
    return row;
  }
  function parseBundleResponse(html) {
    var source = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ck-cart-bundles]');
    if (!source) return [];
    try { return JSON.parse(source.textContent) || []; } catch (error) { return []; }
  }
  function loadBundles(cart, signal) {
    if (!(cart.items || []).some(function (item) { return item.has_components; })) return Promise.resolve([]);
    return fetch('/?section_id=carska-cart-bundle-data', { headers: { Accept: 'text/html' }, signal: signal })
      .then(function (response) { return response.ok ? response.text() : ''; }).then(parseBundleResponse)
      .catch(function (error) { if (error.name !== 'AbortError') toast('Nie udało się pobrać szczegółów zestawu.'); return []; });
  }
  function renderBundles(bundles) {
    bundles.forEach(function (bundle) {
      var host = qsa('[data-bundle-key]').find(function (node) { return node.dataset.bundleKey === String(bundle.key); });
      if (!host) return;
      var list = el('ul', 'ci-bundle-list');
      (bundle.components || []).forEach(function (component) {
        var row = el('li', 'ci-bundle-row'), thumbnail = el('span', 'ci-bundle-img'), componentImage = image(component.image, 80);
        if (componentImage) thumbnail.appendChild(componentImage);
        row.appendChild(thumbnail); row.appendChild(el('span', 'ci-bundle-row-title', component.quantity + ' × ' + String(component.title || '').replace(/^Carska\s+/i, ''))); list.appendChild(row);
      });
      if (list.childNodes.length) { host.replaceChildren(list); host.hidden = false; }
    });
  }
  function fetchProduct(handle) {
    if (Object.prototype.hasOwnProperty.call(upsellCache, handle)) return upsellCache[handle];
    upsellCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; }).catch(function () { return null; });
    return upsellCache[handle];
  }
  function renderOfferCard(offer, rule) {
    var card = el('article', 'cu-card' + (rule.featured ? ' cu-card--featured' : '')), link = el('a', 'cu-img'), body = el('div', 'cu-body'); link.href = safeUrl(offer.url);
    var productImage = image(offer.image, 200); if (productImage) link.appendChild(productImage); card.appendChild(link);
    if (rule.label) body.appendChild(el('p', 'cu-label', rule.label));
    var title = el('a', 'cu-title', offer.title); title.href = safeUrl(offer.url); body.appendChild(title);
    if (offer.quantity) body.appendChild(el('span', 'cu-qty', offer.quantity));
    if (rule.featured && rule.note) body.appendChild(el('p', 'cu-note', rule.note));
    var price = el('span', 'cu-price'); if (offer.compareAtPrice) price.appendChild(el('del', null, money(offer.compareAtPrice))); price.appendChild(document.createTextNode(money(offer.price))); body.appendChild(price); card.appendChild(body);
    var add = el('button', 'cu-add'); add.type = 'button'; add.dataset.upsellAdd = offer.variantId; add.dataset.offerHandle = offer.handle; add.dataset.offerType = rule.featured ? 'high_cart_featured' : (rule.label === 'Uzupełnij koszyk' ? 'fallback' : (rule.anchor ? 'anchor' : 'high_cart')); add.dataset.cartMutation = ''; add.setAttribute('aria-label', 'Dodaj ' + offer.title + ' do koszyka'); add.appendChild(icon(BAG_ICON)); card.appendChild(add); return card;
  }
  function trackOffer(eventName, node, cart) {
    try {
      if (!window.gtag) return;
      window.gtag('event', eventName, { offer_type: node.offerType || 'unknown', offer_handle: node.offerHandle || '', cart_value: cart && typeof cart.total_price === 'number' ? cart.total_price / 100 : undefined, currency: 'PLN' });
    } catch (error) { /* Tracking never blocks cart state. */ }
  }
  /* Oferty: drawer ([data-cart-upsell]) i strona /cart ([data-cart-offers]). Ten sam plan, te same karty. */
  function renderOffers(cart, bundles, version) {
    var targets = [];
    var drawerWrap = qs('[data-cart-upsell]'), drawerList = qs('[data-cart-upsell-list]');
    if (drawerWrap && drawerList) targets.push({ wrap: drawerWrap, list: drawerList });
    qsa('[data-cart-offers]').forEach(function (wrap) { var list = qs('[data-cart-offers-list]', wrap); if (list) targets.push({ wrap: wrap, list: list }); });
    if (!targets.length) return;
    var plan = core.buildOfferPlan(cart, bundles, OFFER_RULES, { threshold: OFFER_CART_THRESHOLD }).slice(0, OFFER_FETCH_CAP);
    Promise.all(plan.map(function (rule) { return fetchProduct(rule.handle).then(function (product) { return { rule: rule, offer: product && product.featured_image ? core.toUpsellOffer(product) : null }; }); })).then(function (results) {
      if (!renderVersion.isCurrent(version)) return;
      var picks = results.filter(function (result) { return result.offer; }).slice(0, OFFER_MAX);
      targets.forEach(function (target) {
        target.list.replaceChildren(); picks.forEach(function (pick) { target.list.appendChild(renderOfferCard(pick.offer, pick.rule)); });
        target.wrap.style.display = picks.length ? '' : 'none';
      });
      picks.forEach(function (pick) { trackOffer('cart_offer_view', { offerType: pick.rule.featured ? 'high_cart_featured' : (pick.rule.anchor ? 'anchor' : 'fallback'), offerHandle: pick.rule.handle }, cart); });
    });
  }
  function renderCart(cart, version, signal) {
    if (!cart || !Array.isArray(cart.items) || !renderVersion.isCurrent(version)) return;
    setCount(cart.item_count);
    var items = qs('[data-cart-items]'), foot = qs('[data-cart-foot]'), empty = qs('[data-cart-empty]'); if (!items) return;
    items.replaceChildren(); cart.items.forEach(function (item, index) { items.appendChild(renderItem(item, index)); });
    if (foot) foot.style.display = cart.item_count ? '' : 'none'; if (empty) empty.style.display = cart.item_count ? 'none' : '';
    var subtotal = qs('[data-cart-subtotal]'); if (subtotal) subtotal.textContent = money(cart.total_price);
    var discount = qs('[data-cart-discount]'); if (discount) { discount.textContent = cart.total_discount > 0 ? 'Oszczędzasz ' + money(cart.total_discount) : ''; discount.hidden = !(cart.total_discount > 0); }
    renderProgress(cart.total_price);
    loadBundles(cart, signal).then(function (bundles) { if (!renderVersion.isCurrent(version)) return; renderBundles(bundles); renderOffers(cart, bundles, version); });
  }
  function readJson(response) { return response.text().then(function (text) { try { return { response: response, data: text ? JSON.parse(text) : null }; } catch (error) { return { response: response, data: null }; } }); }
  function refresh() {
    if (refreshController) refreshController.abort(); refreshController = new AbortController();
    var controller = refreshController, version = renderVersion.next();
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, signal: controller.signal }).then(readJson).then(function (result) {
      if (!result.response.ok || !result.data) throw new Error('invalid-cart-response'); renderCart(result.data, version, controller.signal); return result.data;
    }).catch(function (error) { if (error.name !== 'AbortError') toast('Nie udało się odświeżyć koszyka. Sprawdź połączenie i spróbuj ponownie.'); return null; });
  }
  function mutate(operation) {
    mutationQueue = mutationQueue.then(function () {
      setBusy(true); return operation().catch(function () { toast('Błąd połączenia. Spróbuj ponownie.'); return null; }).finally(function () { setBusy(false); });
    }, function () {
      setBusy(true); return operation().catch(function () { toast('Błąd połączenia. Spróbuj ponownie.'); return null; }).finally(function () { setBusy(false); });
    });
    return mutationQueue;
  }
  function postCart(path, body, headers) { return fetch(path, { method: 'POST', headers: headers, body: body }).then(readJson); }
  function trackAdd(data) {
    try {
      var items = data && data.items ? data.items : (data && data.id ? [data] : []); if (!items.length) return;
      var value = 0, gaItems = [], ids = [];
      items.forEach(function (item) { var price = Number(item.final_price != null ? item.final_price : item.price) / 100, quantity = item.quantity || 1; value += price * quantity; gaItems.push({ item_id: item.sku || String(item.id), item_name: item.product_title || item.title, price: price, quantity: quantity }); ids.push(item.sku || String(item.id)); });
      if (window.gtag) window.gtag('event', 'add_to_cart', { currency: 'PLN', value: value, items: gaItems });
      if (window.fbq) window.fbq('track', 'AddToCart', { content_ids: ids, content_type: 'product', value: value, currency: 'PLN' });
    } catch (error) { /* Tracking never blocks cart state. */ }
  }
  function addVariant(variantId) {
    return mutate(function () { return postCart('/cart/add.js', JSON.stringify({ id: Number(variantId), quantity: 1 }), { 'Content-Type': 'application/json', Accept: 'application/json' }).then(function (result) { if (!result.response.ok || !result.data || result.data.status) { toast(errMsg(result.data, result.response.status)); return refresh(); } trackAdd(result.data); return refresh(); }); });
  }
  function addForm(form, opener) {
    return mutate(function () { return postCart('/cart/add.js', new FormData(form), { Accept: 'application/json' }).then(function (result) { openDrawer(opener); if (!result.response.ok || !result.data || result.data.status) { toast(errMsg(result.data, result.response.status)); return refresh(); } trackAdd(result.data); return refresh(); }); });
  }
  function change(line, quantity) {
    return mutate(function () { return postCart('/cart/change.js', JSON.stringify({ line: line, quantity: quantity }), { 'Content-Type': 'application/json', Accept: 'application/json' }).then(function (result) { if (!result.response.ok || !result.data || result.data.status) { toast(errMsg(result.data, result.response.status)); return refresh(); } return refresh(); }); });
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]') || event.defaultPrevented) return;
    event.preventDefault(); addForm(form, form.querySelector('[type="submit"]'));
  });
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-cart-open]'); if (opener) { event.preventDefault(); openDrawer(opener); return; }
    if (event.target.closest('[data-cart-close]')) { event.preventDefault(); closeDrawer(); return; }
    var upsell = event.target.closest('[data-upsell-add]');
    if (upsell) {
      addVariant(upsell.dataset.upsellAdd).then(function (cart) {
        if (cart) trackOffer('cart_offer_add', upsell.dataset, cart);
        if (cart && qs('[data-cart-offers-page]')) window.location.reload(); // strona /cart jest renderowana w Liquid
      });
      return;
    }
    var action = event.target.closest('.ci-dec, .ci-inc, .ci-x');
    if (action) { var line = Number(action.dataset.line), quantity = Math.max(0, Number(action.dataset.qty)); if (Number.isInteger(line) && Number.isInteger(quantity)) change(line, quantity); }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) { event.preventDefault(); closeDrawer(); return; }
    if (event.key !== 'Tab' || !isOpen()) return;
    var nodes = focusables(); if (!nodes.length) return; var first = nodes[0], last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('DOMContentLoaded', function () {
    drawer = qs('[data-cart-drawer]'); overlay = qs('[data-cart-overlay]'); if (!drawer || !overlay) return;
    qsa('[data-cart-open]').forEach(function (node) { node.setAttribute('aria-controls', drawer.id); node.setAttribute('aria-expanded', 'false'); });
    refresh();
  });
})();
